import EstornarItemPedidoInput from '@/core/apiclient/item-pedido/estorno/models/EstornarItemPedidoInput'

export default {
	form: new EstornarItemPedidoInput([], null, null),
}
